import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { filter, first } from 'rxjs';
import { AddressListComponent } from 'src/app/components/address-list/address-list.component';
import { LoaderComponent } from 'src/app/components/loader/loader.component';
import { User } from '../../../../models/user';
import { AuthService } from '../../../../services/auth.service';
import { CompanyService } from '../../../../services/company.service';

@Component({
    selector: 'app-profile-tab-addresses',
    templateUrl: './profile-tab-addresses.component.html',
    styleUrls: ['./profile-tab-addresses.component.scss'],
    imports: [CommonModule, LoaderComponent, AddressListComponent],
})
export class ProfileTabAddressesComponent implements OnInit {
    companyId: number;
    user: User;
    companyRoleMap: { shipping?: number; return?: number; billing?: number } = {};
    loading = true;

    constructor(
        private readonly authService: AuthService,
        private readonly companyService: CompanyService,
    ) {}

    ngOnInit() {
        this.authService.userLoggedIn
            .pipe(filter((user) => !!user))
            .pipe(first())
            .subscribe((user) => {
                this.user = user;
                if (this.user.type === 'pro') {
                    this.companyId = this.user.company;
                    this.loadCompanyRoleMap();
                }
                this.loading = false;
            });
    }

    private loadCompanyRoleMap() {
        if (!this.companyId) return;
        this.companyService.getAddresses(this.companyId).subscribe((addresses) => {
            this.companyRoleMap = {
                shipping: addresses.shipping?.id ?? undefined,
                return: addresses.return?.id ?? undefined,
                billing: addresses.billing?.id ?? undefined,
            };
        });
    }

    onRoleUpdated() {
        this.loadCompanyRoleMap();
    }
}
